var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.495 5.8a1 1 0 01-1.99 0H4v1.6h16V5.8h-1.605a1 1 0 01-1.99 0h-7.91zm0 0h7.91-7.91zM6.5 3.8V3a1 1 0 012 0v.8h7.9V3a1 1 0 112 0v.8h1.7c1.05 0 1.9.85 1.9 1.9V19a3 3 0 01-3 3H5a3 3 0 01-3-3V5.7c0-1.05.85-1.9 1.9-1.9h2.6zM20 9.4H4V19a1 1 0 001 1h14a1 1 0 001-1V9.4zM6.6 13a1 1 0 110-2h3.6a1 1 0 110 2H6.6zm0 3.6a1 1 0 110-2h7.2a1 1 0 110 2H6.6z",
    fill: "#29CC8B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.cffa0821a8545f0756a91b24318bd6fd.svg";
export { ForwardRef as ReactComponent };